import React from "react";
import { Container, Grid, Box, Typography, Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import Img from "gatsby-image";

const useStyles = makeStyles((theme) => ({
  container: {
    padding: 10,
    border: "2px solid rgb(240,240,240)",
    borderBottom: 0,
    borderRight: 0,
    borderLeft: 0,
  },
  cartContents: {
    padding: "20px 20px",
  },
}));

const CartItem = (props) => {
  console.log(props);
  const classes = useStyles();
  return (
    <Grid container item xs={12} className={classes.container}>
      {/*  Product Image */}
      <Grid container item component={Box} item xs={2} alignItems="center">
        <img
          src={props.product.product_image}
          alt={props.product.product_title}
          style={{
            width: "100%",
            maxHeight: 80,
            objectFit: "cover",
            borderRadius: 18,
          }}
        />
      </Grid>
      {/*  Product Contents */}
      <Grid
        container
        item
        xs={10}
        className={classes.cartContents}
        alignContent="space-between"
      >
        {/*  Product Title */}
        <Grid component={Box} item xs={12} style={{ marginBottom: 0 }}>
          <Typography variant="body1" style={{ fontWeight: 700 }}>
            {props.product.product_title}
          </Typography>
          <Typography
            variant="body1"
            style={{ fontWeight: 300, color: "gray" }}
          >
            {props.product.type}
          </Typography>

          <Typography
            variant="body2"
            onClick={(e) => {
              e.preventDefault();
              props.removeFromCart(props.product);
            }}
            style={{ color: "rgb(255,0,0)", marginTop: 5, cursor: "pointer" }}
          >
            Remove
          </Typography>
        </Grid>
        {/*  Product Total */}
        <Grid component={Box} item xs={3}>
          <Typography variant="body2" style={{ fontWeight: 600 }}>
            ${props.product.price * props.product.quantity}
          </Typography>
        </Grid>
        {/*  Product Quantity + Price */}
        <Grid component={Box} item xs={9} align="center">
          <div
            style={{
              background: "rgb(240,240,240)",
              borderRadius: "20px",
              float: "right",
              cursor: "pointer",
            }}
          >
            <span
              style={{
                fontWeight: 600,
                display: "inline-block",
                padding: 2,
                width: 30,
                margin: 0,
                cursor: "pointer",
              }}
              onClick={(e) => {
                e.preventDefault();
                if (props.product.quantity > 1) {
                  props.decreaseQuantity(props.product);
                }
              }}
            >
              -
            </span>
            <Typography
              variant="body2"
              style={{
                fontWeight: 600,
                display: "inline-block",
                cursor: "pointer",
              }}
            >
              {props.product.quantity}
            </Typography>
            <span
              style={{
                fontWeight: 600,
                display: "inline-block",
                padding: 2,
                width: 30,
                cursor: "pointer",
              }}
              onClick={(e) => {
                e.preventDefault();
                props.increaseQuantity(props.product);
              }}
            >
              +
            </span>
          </div>
        </Grid>
      </Grid>
    </Grid>
  );
};
export default CartItem;
